import { createAction } from '@reduxjs/toolkit';

export const fetchMulticall = createAction<void>('token/fetchMulticall');
export const fetchMulticallSuccess = createAction<{ owned: string[] }>(
  'token/fetchMulticallSuccess',
);
export const fetchMulticallError = createAction<{ error: Error }>('token/fetchMulticallError');
